module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-home-layout', [_c('filter-yellow', {
    attrs: {
      "slot": "search",
      "route": "events",
      "fields": _vm.filterFields,
      "values": _vm.filterValuesLocal,
      "nav": _vm.navSwitcher
    },
    slot: "search"
  }), _c('slider-default', {
    attrs: {
      "slot": "presentation",
      "items": _vm.slidesList,
      "path": {
        name: 'blog'
      }
    },
    slot: "presentation"
  }), _c('catalog-list', {
    attrs: {
      "slot": "events",
      "visible": _vm.isMounted,
      "items": _vm.eventsList,
      "doubler": _vm.isMounted ? _vm.doubler : null,
      "button-visible": true,
      "link-to": {
        name: 'events'
      },
      "title": "Каталог программ"
    },
    slot: "events"
  }, [_c('div', {
    attrs: {
      "slot": "after"
    },
    slot: "after"
  }, [_c('ext-button', {
    attrs: {
      "transparent": true,
      "factor": 1.4,
      "fill": false,
      "to": _vm.showAllRoute,
      "color": "green",
      "size": "small"
    }
  }, [_vm._v("Показать все")])], 1)]), _c('dashboard', {
    attrs: {
      "slot": "dashboard"
    },
    slot: "dashboard"
  }), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-355993ed","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/Home.vue
// module id = 7b90a67bf96e2b3bcb40
// module chunks = 16